import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from './Login'; // Ensure this is imported
import ErrorPage from './Components/ErrorPage';
import ProtectedRoute from './ProtectedRoute';
import Header from './Components/Header';
import Footer from './Components/Footer';
import Home from './Components/Home';
import SideNav from './Components/SideNav';
import FormPreviewPage from './Components/CommonComponents/FormMasterPreviewPage';
import FormView from './Components/CommonComponents/FormView';
import GenerateExternalForm from './Components/FormDesignerComponents/GenerateExternalForm';
import ViewExternalForm from './Components/FormDesignerComponents/FormMasterView/ViewExternalForm';

function App() {

  return (
    <Router>
      <div className="App" style={{ height: '100%' }}>
        <Routes>
          {/* Public Route: Login with ID as a parameter */}
          <Route path="/login/:id" element={<LoginPage />} />
          <Route path="/editor/form-preview" element={<FormPreviewPage/>} />
          <Route path="/form-preview/:id" element={<FormView />} />
          <Route path="/editor/GenerateExternalForm/:formMasterGuid" element={<GenerateExternalForm/>}/>
         <Route path="/editor/ViewExternalForm/:formId" element={<ViewExternalForm/>}/>
          {/* Protected Route */}
          <Route path="/editor/*" element={
            
            <ProtectedRoute>
            

              <Header />
              <SideNav />
              <Home />
              <Footer />
            </ProtectedRoute>
          } />
          <Route path="/errorpage" element={<ErrorPage />} />
          <Route path="*" element={<Navigate to="/errorpage" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
